import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-form-actions',
  templateUrl: './form-actions.component.html',
  styleUrls: ['./form-actions.component.scss']
})
export class FormActionsComponent implements OnInit {

  @Input() cancelDisabled: boolean;
  @Input() cancelLabel: string;
  @Input() cancelIcon: string;
  @Input() cancelClass: string;
  @Input() saveDisabled: boolean;
  @Input() saveLabel: string;
  @Input() saveIcon: string;
  @Input() saveClass: string;

  @Output() cancel = new EventEmitter(null);
  @Output() save = new EventEmitter();


  constructor() {
  }

  ngOnInit() {
  }

  onCancel(evt: any): void {
    this.cancel.emit(evt);
  }

  onSave(evt: any): void {
    this.save.emit(evt);
  }

  get isCancel(): boolean {
    return this.cancel.observers.length > 0;
  }


  get isSave(): boolean {
    return this.save.observers.length > 0;
  }
}
